import React from "react"
import {Box, Divider, Typography} from "@mui/material";
import {DefaultComponentProps} from "@mui/types";
import CCORichText from "./CCORichText/CCORichText";
import CCOContainer from "./CCOContainer";
import CCOHeadlineComponentHead from "./CCOHeadlineComponentHead";
import {RichTextElement} from "./CCORichText/CCORichTextHelper";
import PreviewPropertyHighlighter from "../preview/PreviewPropertyHighlighter";
import {metaDataProperty} from "../preview/previewMetaData";
import {usePreviewContext} from "../../context/PreviewContext";

interface Props {
    propertyName?: string,
    subtextPropertyName?: string,
    roofLine?: any,
    roofLineCharLimit?: number,
    headline?: any,
    headlineCharLimit?: number,
    type?: DefaultComponentProps<any>,
    limit?: number,
    strong?: boolean,
    subtext?: RichTextElement,
    subtextCharLimit?: number,
    subheadline?: any,
    color?: string,
    margin?: { b?: number | string, t?: number | string, l?: number | string, r?: number | string },
    justify?: string,
    background?: string,
    id?: string,
    className?: any,
    divider?: boolean,
    isRichText?: boolean,
    dataCypress?: string
    metadataId?: string
}

function CCOHeadline(props: Props) {
    const preview = usePreviewContext().isPreview;
    function renderHeadline() {
        return <CCOHeadlineComponentHead propertyName={props.propertyName}
                                         subtextPropertyName={props.subtextPropertyName}
                                         roofLineCharLimit={props.roofLineCharLimit}
                                         headline={props.headline}
                                         headlineCharLimit={props.headlineCharLimit}
                                         type={props.type}
                                         limit={props.limit}
                                         strong={props.strong}
                                         subtext={props.subtext}
                                         subtextCharLimit={props.subtextCharLimit}
                                         subheadline={props.subheadline}
                                         color={props.color}
                                         margin={props.margin}
                                         justify={props.justify}
                                         background={props.background}
                                         id={props.id}
                                         metadataId={props.metadataId}
                                         dataCypress={props.dataCypress}/>
    }
    function renderHeadlineTitle() {
        if (props.headlineCharLimit) {
            return props.headline.substring(0, props.headlineCharLimit);
        } else {
            if (props.limit) {
                if (props.headline.length <= props.limit) {
                    return props.headline;
                } else {
                    return props.headline.substring(0, props.limit) + "...";
                }
            } else {
                return props.headline;
            }
        }
    }

    if (props.type === 'componenthead' && props.headline && props.headline.length > 0 ) {
        return props.isRichText ? renderHeadline()
            : <CCOContainer id={props.id} background={props.background} width={"small"}>
                {renderHeadline()}
            </CCOContainer>
    } else return <Box sx={{
        display: "flex",
        justifyContent: props.justify ?? "center",
        alignItems: props.justify ?? "center",
        flexDirection: "column"
    }}>
        {props.roofLine ?
            <Box
                sx={{display: "flex", justifyContent: props.justify ?? "center", flexDirection: "column", marginTop: props.margin?.t ?? undefined, paddingBottom: "16px", lineHeight: '1'}}>
                <Typography variant={'overline'} fontWeight={'bold'} color={props.color ?? undefined}>
                    {props.roofLineCharLimit ? props.roofLine.substring(0, props.roofLineCharLimit) +
                        (props.roofLine.length > props.roofLineCharLimit ? '...' : '') : props.roofLine}
                </Typography>
                <Divider sx={{width: 100, height: 4, bgcolor: 'primary.main', marginBottom: 4}}/>
            </Box>
            : null
        }
        <Box marginBottom={props.margin?.b ?? undefined}
             marginLeft={props.margin?.l ?? undefined}
             marginTop={props.margin?.t ?? undefined}
             marginRight={props.margin?.r ?? undefined}>
            {typeof props.headline === 'string' ?
                (<Typography data-cypress={props.dataCypress} className={props.className ? props.className : ''}
                                variant={props.type ? props.type : 'h2'}
                                gutterBottom={true}
                                {...metaDataProperty(preview, props.propertyName, props.metadataId)}
                                color={props.color ?? undefined} fontWeight={props.strong ? 'strong' : 'normal'} >{renderHeadlineTitle()}</Typography>) :
                <Box sx={{textAlign: 'center', alignItems: 'center'}}>
                    <CCORichText metadataId={props.metadataId} data-cypress={props.dataCypress} textAsTree={props.headline} charLimit={props.headlineCharLimit}
                                 variant={props.type ? props.type : 'h2'} color={props.color ?? undefined}
                                 strong={props.strong}
                                 propertyName={props.propertyName}
                                 alignContent={props.justify as "center" | "right" | "left" | "inherit" | "justify" | undefined}/>
                </Box>
            }

        </Box>

    </Box>
}

export default CCOHeadline